import type { RouteObject } from 'react-router-dom';
import { ReleasedFeature } from '../../release';
import { RequirePermission } from '../auth/guards';
import { ReviewQueuePage } from './ReviewQueuePage';
import {
  DropshipOrdersPage,
  EquipmentRequestsPage,
  ShipmentDashboardPage,
  ShippingQueuePage,
} from './ShipmentPages';
import { ShipperInventoryPage } from './ShipperInventoryPage';

const guard = (code: string, element: JSX.Element) => (
  <RequirePermission code={code}>{element}</RequirePermission>
);

/**
 * What happens to an order after the enrollment wizard: Review (PC426), the shipment screens
 * of the Inventory menu (PC7, PC1066) and the Shipment menu (PC383).
 */
export const ordersRoutes: RouteObject[] = [
  { path: 'review/fraud-orders', element: guard('PC984', <ReviewQueuePage />) },
  { path: 'inventory/dropship-orders', element: guard('PC7', <DropshipOrdersPage />) },
  {
    path: 'inventory/dropship-orders/shipper-inventory',
    element: guard(
      'PC7',
      <ReleasedFeature name="shipper-inventory" page>
        <ShipperInventoryPage />
      </ReleasedFeature>,
    ),
  },
  { path: 'inventory/shipping-queue', element: guard('PC1066', <ShippingQueuePage />) },
  { path: 'shipment/dashboard', element: guard('PC223', <ShipmentDashboardPage />) },
  { path: 'shipment/equipment-requests', element: guard('PC538', <EquipmentRequestsPage />) },
];
